import BaseClient from '@/app/model/api/response/baseApiClient'

class MypageApi extends BaseClient {
  public getUserData () {
    const path = '/v1/information/user'

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'GET')
  }
}

export default new MypageApi()
